// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:34:44

export default {
  "id": "war-state-io-conquer-battles",
  "slug": "war-state-io-conquer-battles",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e1e486c81b0c4d738d4c1a05204f99c2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e1e486c81b0c4d738d4c1a05204f99c2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "War State IO - Conquer Battles",
      "description": "Welcome to ultimate strategy game that lets you improve your tactical skills and lead your troops to triumph! \n\nLead your army, conquer enemy camps, and expand your territory in fast-paced battles filled with action and strategy.\n\nEvery decision matters — whether you’re attacking enemy strongholds or defending your bases, clever maneuvers are key to achieving victory.",
      "instructions": "Drag your troops with your mouse/finger to the building you want to occupy.\nOccupy all enemy buildings to win.",
      "genres": [
        ".IO",
        "Strategy"
      ],
      "tags": [
        "army",
        "military",
        "soldier",
        "tank",
        "war"
      ]
    },
    "zh-CN": {
      "title": "战争状态IO - 征服战役",
      "description": "欢迎来到这款终极策略游戏，让您提升战术技能，并带领您的部队走向胜利！\n\n指挥您的军队，征服敌军营地，在充满动作和策略的快节奏战斗中扩张您的领土。\n\n每一个决策都至关重要——无论是进攻敌军要塞还是防御您的基地，巧妙的机动是取得胜利的关键。",
      "instructions": "用鼠标/手指拖动您的部队到您想要占领的建筑。\n占领所有敌方建筑以获胜。",
      "genres": [
        ".IO",
        "策略"
      ],
      "tags": [
        "军队",
        "军事",
        "士兵",
        "坦克",
        "战争"
      ]
    },
    "zh-TW": {
      "title": "戰國IO - 征服戰役",
      "description": "歡迎來到最終策略遊戲，讓你提升你的戰術技巧並領導你的部隊走向勝利！\n\n領導你的軍隊，征服敵人營地，並在充滿動作與策略的快節奏戰鬥中擴張你的領土。\n\n每個決定都至關重要——無論是攻擊敵人要塞還是防衛你的基地，精巧的戰術是取得勝利的關鍵。",
      "instructions": "用滑鼠/手指拖動您的部隊到您想要佔領的建築物。\n佔領所有敵方建築物以獲勝。",
      "genres": [
        ".IO",
        "策略"
      ],
      "tags": [
        "軍隊",
        "軍事",
        "士兵",
        "坦克",
        "戰爭"
      ]
    },
    "zh-HK": {
      "title": "戰國IO - 征服戰役",
      "description": "歡迎來到最終策略遊戲，讓你提升你的戰術技巧，並領導你的部隊走向勝利！\n\n領導你的軍隊，征服敵人營地，並在充滿動作和策略的快速戰鬥中擴展你的領土。\n\n每個決定都至關重要——無論是攻擊敵人要塞還是防衛你的基地，精明運籌是取得勝利的關鍵。",
      "instructions": "用鼠標/手指拖動你的軍隊到你想佔領的大樓。\n佔領所有敵人建築物以獲勝。",
      "genres": [
        ".IO",
        "策略"
      ],
      "tags": [
        "軍隊",
        "陸軍",
        "士兵",
        "坦克",
        "戰爭"
      ]
    },
    "ja": {
      "title": "ウォー・ステート・アイオー - 奥地征服",
      "description": "究極の戦略ゲームへようこそ！あなたの戦術スキルを向上させ、部隊を勝利に導くことができるゲームです。\n\nあなたの軍を率いて、敵のキャンプを征服し、速攻の戦闘で行動と戦略を駆使して領土を拡大しましょう。\n\nどんな決定も大切です。敵の要塞を攻撃するのか、基地を守るのか、賢明な動きが勝利への鍵となります。",
      "instructions": "マウスまたは指であなたの軍隊を占領したい建物にドラッグしてください。\n敵の全ての建物を占領して勝利しましょう。",
      "genres": [
        ".IO",
        "戦略"
      ],
      "tags": [
        "軍隊",
        "軍事",
        "兵士",
        "戦車",
        "戦争"
      ]
    },
    "ko": {
      "title": "ウォ어ステ이트 IO - 전쟁을 통칭하다",
      "description": "최상의 전략 게임을 환영합니다. 전술 기술을 향상시키고 병력을 이끌어 승리로 이끌 수 있는 게임입니다!\n\n병력을 이끌고 적의 캠프를 점령하고 빠른 속도의 전투에서 전략을 사용하여 영토를 확장하세요.\n\n모든 결정이 중요합니다. 적의 강력한 포지션을 공격하거나 본거지를 방어하는 것은 어떤 경우에도 지혜로운 전략이 승리의 열쇠입니다.",
      "instructions": "마우스나 손가락으로 부대를 건물로 이동시켜 점령하세요.\n모든 적 건물을 점령하여 승리하세요.",
      "genres": [
        "..IO",
        "전략"
      ],
      "tags": [
        "군대",
        "군사",
        "병사",
        "탱크",
        "전쟁"
      ]
    },
    "fr": {
      "title": "État de guerre IO - Conquêtes de batailles",
      "description": "Bienvenue dans le jeu de stratégie ultime qui vous permet d'améliorer vos compétences tactiques et de diriger vos troupes vers la victoire !\n\nDirigez votre armée, conquérez les camps ennemis et étendez votre territoire dans des batailles rapides remplies d'action et de stratégie.\n\nChaque décision compte, que vous soyez en train d'attaquer les forteresses ennemies ou de défendre vos bases, des manœuvres intelligentes sont essentielles pour obtenir la victoire.",
      "instructions": "Faites glisser vos troupes avec votre souris ou doigt vers le bâtiment que vous souhaitez occuper.\nOccupez tous les bâtiments ennemis pour gagner.",
      "genres": [
        ".IO",
        "Stratégie"
      ],
      "tags": [
        "armée",
        "militaire",
        "soldat",
        "char",
        "guerre"
      ]
    }
  }
};
